import React, { SFC } from "react";
import "./style.scss";

type PropsType = {
    id: string;
    label: string;
};

const FormRow = (props): SFC => {
    return (
        <div className="FormRow">
            <label className="FormRow__label" htmlFor={props.id}>
                {props.label}
            </label>
            {props.children}
        </div>
    );
};

export default FormRow;
